// CSS Modules - component class name: FormTextarea__

<template>
  <div :class="[$style.container, { FormTextarea__error: this.error }]">
    <label :class="[$style.label, {FormTextarea__optional: this.optionalLabel }]">
      {{ label }}
      <span v-if="optionalLabel">({{ optionalLabel }})</span>
    </label>
    <textarea :rows="rows" :columns="columns" :value="value" @input="handleInput"></textarea>
    <div v-if="error" :class="$style.errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    value: String,
    label: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    optionalLabel: String
  },
  methods: {
    handleInput($event) {
      this.$emit("input", $event.target.value);
    }
  }
};
</script>

<style module lang="scss">
@import "./FormTextarea.scss";
</style>
